import * as React from 'react';
import Box from '@mui/material/Box';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import Logout from '@mui/icons-material/Logout';
import { useAuthContext, useHasPermission } from '../../../../contexts/auth';
import { useNavigate } from 'react-router-dom';
import { AccountCircle } from "@mui/icons-material";
import styles from "./profileMenu.module.css";
import ApartmentIcon from '@mui/icons-material/Apartment';
import { useTranslation } from 'react-i18next';

export const ProfileMenu = () => {
  const { t } = useTranslation();
  const { logout } = useAuthContext();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const canViewTenant = useHasPermission("app.change_tenant");
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <React.Fragment>
      <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
        <Tooltip
          title={<Typography variant="body2">{t("Profile")}</Typography>}
          placement="right"
        >
          <IconButton size="small" className={styles.icon} aria-label="profile" onClick={handleClick}>
            <AccountCircle fontSize="inherit" />
          </IconButton>
        </Tooltip>
      </Box>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        slotProps={{
          paper: {
            elevation: 0,
            sx: {
              overflow: 'visible',
              filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
              mb: 1.5,
              '& .MuiAvatar-root': {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
      >
        <MenuItem onClick={() => navigate('/profile')}>
          <ListItemIcon>
            <AccountCircle fontSize="medium" />
          </ListItemIcon>
          {t("Profile")}
        </MenuItem>
        {canViewTenant && (
          <MenuItem onClick={() => navigate('/tenant')}>
            <ListItemIcon>
                <ApartmentIcon fontSize="medium" />
            </ListItemIcon>
            {t("Workspace")}
          </MenuItem>
        )}
        <Divider />
        <MenuItem onClick={() => logout()}>
          <ListItemIcon>
            <Logout fontSize="medium" />
          </ListItemIcon>
          {t("Logout")}
        </MenuItem>
      </Menu>
    </React.Fragment>
  );
};
